export default __webpack_public_path__ + "static/media/rosemount.17e74a42.png";